// MetroSupps interactions
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  /* ----- Reveal on scroll ----- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    reveals.forEach((el) => io.observe(el));
    // Safety net: if anything is still hidden after 2.5s (e.g. user never scrolled), reveal it.
    setTimeout(() => { document.querySelectorAll('.reveal:not(.is-in)').forEach((el) => el.classList.add('is-in')); }, 2500);
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ----- Goal finder chips: filter product cards on home ----- */
  const chips = document.querySelectorAll('[data-goal-chip]');
  const goalCards = document.querySelectorAll('[data-goals]');
  if (chips.length && goalCards.length) {
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const goal = chip.dataset.goalChip;
        chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
        goalCards.forEach((card) => {
          const goals = (card.dataset.goals || '').split(',').map((s) => s.trim());
          const visible = goal === 'all' || goals.includes(goal);
          card.style.display = visible ? '' : 'none';
        });
      });
    });
  }

  /* ----- Flavor / variant dot toggle on cards ----- */
  document.querySelectorAll('[data-flavors]').forEach((group) => {
    const dots = group.querySelectorAll('.flavor-dot');
    const card = group.closest('.card');
    const img = card ? card.querySelector('.card__media img') : null;
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        dots.forEach((d) => d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'));
        const src = dot.dataset.image;
        if (img && src) {
          img.style.opacity = '0';
          setTimeout(() => { img.src = src; img.style.opacity = '1'; }, 120);
        }
      });
      // keyboard support
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dot.click(); }
      });
    });
  });

  /* ----- Sticky add bar (mobile) on home ----- */
  const stickyBar = document.querySelector('[data-sticky-bar]');
  if (stickyBar) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const show = y > 600 && y > lastY - 50; // appear past hero
      stickyBar.classList.toggle('is-visible', show);
      lastY = y;
    }, { passive: true });
  }

  /* ----- Animated number counters ----- */
  const counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cio = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        if (reduce) {
          el.textContent = target.toLocaleString() + suffix;
        } else {
          let start = 0;
          const dur = 1100;
          const t0 = performance.now();
          const step = (now) => {
            const p = Math.min(1, (now - t0) / dur);
            const eased = 1 - Math.pow(1 - p, 3);
            const v = Math.floor(target * eased);
            el.textContent = v.toLocaleString() + suffix;
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
        cio.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach((c) => cio.observe(c));
  }

  /* ----- PDP variant + thumbs ----- */
  document.querySelectorAll('[data-pdp]').forEach((pdp) => {
    const main = pdp.querySelector('[data-pdp-main]');
    pdp.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        pdp.querySelectorAll('[data-pdp-thumb]').forEach((x) => x.setAttribute('aria-pressed', x === t ? 'true' : 'false'));
        const src = t.dataset.image;
        if (main && src) main.src = src;
      });
    });
    pdp.querySelectorAll('[data-variant-group]').forEach((group) => {
      group.querySelectorAll('button').forEach((b) => {
        b.addEventListener('click', () => {
          group.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        });
      });
    });
  });

  /* ----- Cart count (local-only stub for preview) ----- */
  const cartCount = document.querySelector('[data-cart-count]');
  let count = 0;
  document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      count += 1;
      if (cartCount) cartCount.textContent = String(count);
      btn.classList.add('is-added');
      const orig = btn.textContent;
      btn.textContent = 'Added';
      setTimeout(() => { btn.textContent = orig; btn.classList.remove('is-added'); }, 1200);
    });
  });

  /* ----- Newsletter form (preview) ----- */
  document.querySelectorAll('[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const status = form.querySelector('[data-newsletter-status]');
      if (status) status.textContent = 'Welcome to the gym. Check your inbox.';
      form.reset();
    });
  });

})();
